import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
	providedIn: 'root'
})
export class OneSignalService {
	private initialized = false;

	constructor() { }

	oneSignal(): void {
		if (typeof window === 'undefined') return;

		(window as any).OneSignalDeferred = (window as any).OneSignalDeferred || [];

		(window as any).OneSignalDeferred.push(async (OneSignal: any) => {
			try {
				await OneSignal.init({
					appId: environment.ONESIGNAL_APP_ID,
					notifyButton: { enable: true },
					allowLocalhostAsSecureOrigin: true
				});

				this.initialized = true;

				const id = await OneSignal.User?.PushSubscription?.id;

				if (id) {
					this.savePlayerId(id);
				}

				OneSignal.User?.PushSubscription?.addEventListener('change', (event: any) => {
					const newId = event?.target?.id || event?.current?.id;

					if (newId) {
						this.savePlayerId(newId);
					}
				});

			} catch (error) {
				console.error('[OneSignal] Init error:', error);
			}
		});
	}

	async waitForPlayerIdAndSave(): Promise<void> {

		for (let i = 0; i < 15; i++) {
			await new Promise(r => setTimeout(r, 500));

			const id = (window as any).OneSignal?.User?.PushSubscription?.id;

			if (id) {
				localStorage.setItem('onesignal_player_id', id);
				return;
			}
		}
	}

	clearOneSignalPlayerId(): void {
		localStorage.removeItem('onesignal_player_id');
		localStorage.removeItem('onesignal_player_id_timestamp');
	}

	private isPlayerIdFresh(): boolean {
		const ts = localStorage.getItem('onesignal_player_id_timestamp');
		if (!ts) return false;
		const ageMs = Date.now() - parseInt(ts, 10);
		return ageMs < 7 * 24 * 60 * 60 * 1000;
	}

	private savePlayerId(id: string): void {
		localStorage.setItem('onesignal_player_id', id);
		localStorage.setItem('onesignal_player_id_timestamp', Date.now().toString());
	}

	async getPlayerId(): Promise<string | null> {
		const cached = localStorage.getItem('onesignal_player_id');
		if (cached && this.isPlayerIdFresh()) return cached;

		// Cache is stale or missing — clear and re-fetch
		this.clearOneSignalPlayerId();

		try {
			const id = await (window as any).OneSignal?.User?.PushSubscription?.id;
			if (id) {
				this.savePlayerId(id);
				return id;
			}
		} catch (error) {
			console.error('[OneSignal] getPlayerId error:', error);
		}
		return null;
	}

	async requestPermission(): Promise<NotificationPermission> {
		const permission = await Notification.requestPermission();
		return permission;
	}

	async subscribeUser(): Promise<void> {

		if (!this.initialized) return;

		(window as any).OneSignal?.User?.PushSubscription?.optIn();
	}

	async unsubscribeUser(): Promise<void> {

		if (!this.initialized) {
			return;
		}

		(window as any).OneSignal?.User?.PushSubscription?.optOut();
	}
}